function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M594.6,1143.9l-25.2,20.5c-1.7,1.3-4.2,1.1-5.5-0.6l0,0c-1.3-1.7-1.1-4.2,0.6-5.5l25.2-20.5c1.7-1.3,4.2-1.1,5.5,0.6l0,0 C596.5,1140,596.3,1142.5,594.6,1143.9z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M720.1,1267.5l-50.9,7.8c-1.5,0.2-3.1-0.4-4-1.5c-1-1.1-1.2-2.8-0.7-4.1l18.9-46.6c0.6-1.4,1.8-2.4,3.3-2.6s3.1,0.4,4,1.5 l32,38.8c1,1.1,1.2,2.8,0.7,4.1C722.9,1266.3,721.6,1267.3,720.1,1267.5z M675.2,1266l36.2-5.5l-22.8-27.6L675.2,1266z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M226.9,1211.2c-16.4,0-29.7-13.3-29.7-29.7s13.3-29.7,29.7-29.7s29.7,13.3,29.7,29.7S243.3,1211.2,226.9,1211.2z M226.9,1161.3c-11.2,0-20.3,9.1-20.3,20.3c0,11.2,9.1,20.3,20.3,20.3c11.2,0,20.3-9.1,20.3-20.3S238,1161.3,226.9,1161.3z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M568.9,595.3l19.9,5.1c3.5,0.9,7.1-1.2,8-4.8l0,0c0.9-3.5-1.2-7.1-4.8-8l-19.9-5.1l5.1-19.9c0.9-3.5-1.2-7.1-4.8-8l0,0 c-3.5-0.9-7.1,1.2-8,4.8l-5.1,19.9l-19.9-5.1c-3.5-0.9-7.1,1.2-8,4.8l0,0c-0.9,3.5,1.2,7.1,4.8,8l19.9,5.1l-5.1,19.9 c-0.9,3.5,1.2,7.1,4.8,8l0,0c3.5,0.9,7.1-1.2,8-4.8L568.9,595.3z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif"
}, React.createElement("g", null, React.createElement("path", {
  d: "M133.9,1206.8c-2.4-0.9-4.4-2.8-5.8-5.6c-0.3-0.6-0.6-1.2-0.8-1.8c-0.4-0.8-0.7-1.5-1-2.2c-1.4-2.5-4.4-3.5-7.1-2.6 c-0.9,0.3-1.6,0.8-2.5,1.1c-0.3,0.1-0.6,0.3-0.8,0.4c-3.1,1.6-6.1,1.9-8.6,1c-2.6-1-4.7-3.1-6.1-6.4c-0.2-0.4-0.3-0.8-0.5-1.1 c-0.3-0.8-0.7-1.4-1-2.1c-1.4-2.7-4.5-3.7-7.2-2.7c-0.8,0.3-1.4,0.7-2.2,1c-0.8,0.4-1.4,0.8-2.3,1.1c-5.1,2.2-10,0.5-12.7-4.4 c-0.5-1-0.9-1.8-1.2-2.7c-0.4-0.8-0.7-1.5-1-2.2c-1-1.7-0.4-3.8,1.3-4.9c1.7-1,3.8-0.4,4.9,1.3c0.6,1,1,2,1.4,2.9 c0.3,0.8,0.7,1.4,1,2.1c0.9,1.6,2,2,3.7,1.2c0.6-0.3,1.2-0.6,1.8-0.9c1-0.5,1.9-1,3-1.4c6.1-2.3,12.8,0.1,15.9,5.8 c0.6,1,1,1.9,1.3,2.8c0.1,0.3,0.3,0.7,0.4,1c0.7,1.4,1.3,2.4,2,2.6l0,0c0.7,0.2,1.7,0,3.1-0.7c0.3-0.1,0.5-0.3,0.8-0.4 c1-0.5,2.1-1,3.3-1.5c6-2.2,12.6,0.2,15.6,5.7c0.6,1,1,2,1.4,3c0.2,0.5,0.5,1,0.7,1.5c1,2.2,2.2,2.7,4.4,1.6 c0.4-0.2,0.8-0.4,1.2-0.7c1.1-0.7,2.5-1.3,4.3-1.7c1.9-0.4,3.8,0.8,4.2,2.7c0.4,1.9-0.8,3.8-2.7,4.2c-0.8,0.2-1.5,0.6-2.4,1 c-0.5,0.3-1,0.6-1.6,0.9C139.1,1207.5,136.3,1207.7,133.9,1206.8z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.9,1089.5l-9.4-35.7c-0.3-1,0-2.2,0.8-3c0.8-0.8,1.9-1,3-0.8l35.7,9.6c1,0.3,1.9,1.1,2.2,2.2s0,2.2-0.8,3l-26.2,26 c-0.8,0.8-1.9,1-3,0.8C110.9,1091.4,110.2,1090.5,109.9,1089.5z M107.7,1057.3l6.8,25.5l18.7-18.5L107.7,1057.3z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M317.1,1233.3l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7c-0.9-0.9-2.2-0.9-3.1,0l0,0 c-0.9,0.9-0.9,2.2,0,3.1l4.7,4.7l-4.7,4.7c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0l4.7-4.7l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0 l0,0c0.9-0.9,0.9-2.2,0-3.1L317.1,1233.3z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.2,1002.8L62.1,992c-3.5-0.8-5.9-4.2-5.1-7.8l0,0c0.8-3.5,4.2-5.9,7.8-5.1l53.1,10.8c3.5,0.8,5.9,4.2,5.1,7.8l0,0 C122.3,1001.2,118.8,1003.5,115.2,1002.8z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M663.7,959.2l-6.4-23.9c-0.2-0.7,0-1.4,0.6-2c0.5-0.5,1.2-0.8,2-0.6l23.9,6.5c0.7,0.2,1.2,0.8,1.4,1.4s0,1.4-0.6,2 L667.1,960c-0.5,0.5-1.2,0.8-2,0.6C664.3,960.5,663.8,959.9,663.7,959.2z M662.1,937.6l4.5,17.1l12.5-12.4L662.1,937.6z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.5,1095.1l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7c-0.9-0.9-2.2-0.9-3.1,0l0,0 c-0.9,0.9-0.9,2.2,0,3.1l4.7,4.7l-4.7,4.7c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0l4.7-4.7l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0 l0,0c0.9-0.9,0.9-2.2,0-3.1L43.5,1095.1z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.3,1298.1c-4.1,0-7.3-3.3-7.3-7.3c0-4.1,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3C156.6,1294.8,153.3,1298.1,149.3,1298.1z M149.3,1285.7c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1C154.3,1287.9,152,1285.7,149.3,1285.7z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.5,1301.1l-30.6-44.7c-2.1-3-1.2-7.1,1.7-9.2l0,0c3-2.1,7.1-1.2,9.2,1.7l30.6,44.7c2.1,3,1.2,7.1-1.7,9.2l0,0 C72.6,1304.9,68.5,1304.2,66.5,1301.1z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_2_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M446.7,641.6c0.9-2.4,2.8-4.4,5.6-5.8c0.6-0.3,1.2-0.6,1.8-0.8c0.8-0.4,1.5-0.7,2.2-1c2.5-1.4,3.5-4.4,2.6-7.1 c-0.3-0.9-0.8-1.6-1.1-2.5c-0.1-0.3-0.3-0.6-0.4-0.8c-1.6-3.1-1.9-6.1-1-8.6c1-2.6,3.1-4.7,6.4-6.1c0.4-0.2,0.8-0.3,1.1-0.5 c0.8-0.3,1.4-0.7,2.1-1c2.7-1.4,3.7-4.5,2.7-7.2c-0.3-0.8-0.7-1.4-1-2.2c-0.4-0.8-0.8-1.4-1.1-2.3c-2.2-5.1-0.5-10,4.4-12.7 c1-0.5,1.8-0.9,2.7-1.2c0.8-0.4,1.5-0.7,2.2-1c1.7-1,3.8-0.4,4.9,1.3c1,1.7,0.4,3.8-1.3,4.9c-1,0.6-2,1-2.9,1.4 c-0.8,0.3-1.4,0.7-2.1,1c-1.6,0.9-2,2-1.2,3.7c0.3,0.6,0.6,1.2,0.9,1.8c0.5,1,1,1.9,1.4,3c2.3,6.1-0.1,12.8-5.8,15.9 c-1,0.6-1.9,1-2.8,1.3c-0.3,0.1-0.7,0.3-1,0.4c-1.4,0.7-2.4,1.3-2.6,2l0,0c-0.2,0.7,0,1.7,0.7,3.1c0.1,0.3,0.3,0.5,0.4,0.8 c0.5,1,1,2.1,1.5,3.3c2.2,6-0.2,12.6-5.7,15.6c-1,0.6-2,1-3,1.4c-0.5,0.2-1,0.5-1.5,0.7c-2.2,1-2.7,2.2-1.6,4.4 c0.2,0.4,0.4,0.8,0.7,1.2c0.7,1.1,1.3,2.5,1.7,4.3c0.4,1.9-0.8,3.8-2.7,4.2s-3.8-0.8-4.2-2.7c-0.2-0.8-0.6-1.5-1-2.4 c-0.3-0.5-0.6-1-0.9-1.6C446,646.8,445.8,644,446.7,641.6z"
})));

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M688.9,663.3l35.7-9.4c1-0.3,2.2,0,3,0.8c0.8,0.8,1,1.9,0.8,3l-9.6,35.7c-0.3,1-1.1,1.9-2.2,2.2c-1,0.3-2.2,0-3-0.8 l-26-26.2c-0.8-0.8-1-1.9-0.8-3C687,664.4,687.9,663.5,688.9,663.3z M721,661.2l-25.5,6.8l18.5,18.7L721,661.2z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M682.3,1106.9l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0l0,0c0.9-0.9,0.9-2.2,0-3.1l-4.7-4.7l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0 c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7c-0.9-0.9-2.2-0.9-3.1,0l0,0c-0.9,0.9-0.9,2.2,0,3.1l4.7,4.7l-4.7,4.7 c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0L682.3,1106.9z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M548.9,692.1c0-8.3,6.8-15,15-15c8.3,0,15,6.8,15,15s-6.8,15-15,15C555.6,707.1,548.9,700.4,548.9,692.1z M574.1,692.1 c0-5.6-4.6-10.2-10.2-10.2c-5.6,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2C569.6,702.3,574.1,697.8,574.1,692.1z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M420.2,550.2l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0l0,0c0.9-0.9,0.9-2.2,0-3.1l-4.7-4.7l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0 c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7c-0.9-0.9-2.2-0.9-3.1,0l0,0c-0.9,0.9-0.9,2.2,0,3.1l4.7,4.7l-4.7,4.7 c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0L420.2,550.2z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M369.7,639.7c0-4.1,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3s-3.3,7.3-7.3,7.3C373,647.1,369.7,643.8,369.7,639.7z M382.1,639.7 c0-2.8-2.3-5.1-5.1-5.1s-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1C379.9,644.8,382.1,642.5,382.1,639.7z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M642.2,724.4l18.8,50.9c1.2,3.4-0.5,7.2-3.9,8.5l0,0c-3.4,1.2-7.2-0.5-8.5-3.9l-18.8-50.9c-1.2-3.4,0.5-7.2,3.9-8.5l0,0 C637.2,719.1,641,720.9,642.2,724.4z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_3_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M639.1,869.8c1.6-0.2,3.2,0.4,4.8,1.6c0.4,0.3,0.7,0.6,1,0.8c0.4,0.4,0.8,0.7,1.2,1c1.4,1,3.4,0.8,4.8-0.5 c0.4-0.4,0.8-0.9,1.1-1.3c0.1-0.2,0.2-0.3,0.4-0.5c1.3-1.8,2.9-2.8,4.6-3c1.7-0.2,3.4,0.5,5.2,1.9c0.2,0.2,0.4,0.3,0.6,0.5 c0.4,0.4,0.8,0.7,1.1,1c1.5,1,3.5,0.9,4.9-0.5c0.4-0.4,0.7-0.8,1-1.2c0.3-0.4,0.6-0.9,1-1.2c2.3-2.6,5.5-3.1,8.4-1 c0.6,0.4,1,0.8,1.4,1.1c0.4,0.4,0.8,0.7,1.2,1c1,0.7,1.2,2.1,0.6,3.1c-0.7,1-2.1,1.2-3.1,0.6c-0.6-0.4-1-0.9-1.6-1.2 c-0.4-0.3-0.8-0.7-1.1-1c-1-0.7-1.7-0.6-2.4,0.3c-0.3,0.3-0.5,0.7-0.8,1c-0.4,0.5-0.8,1-1.3,1.6c-2.8,3-7.2,3.4-10.6,1.1 c-0.6-0.4-1-0.8-1.5-1.2c-0.2-0.2-0.4-0.3-0.5-0.5c-0.8-0.7-1.4-1-1.9-0.9l0,0c-0.5,0.1-1,0.5-1.5,1.2c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.4,0.6-0.9,1.1-1.4,1.8c-2.8,2.9-7.1,3.3-10.4,1c-0.6-0.4-1.1-0.9-1.6-1.2c-0.3-0.2-0.5-0.5-0.8-0.7c-1.2-1-2-0.9-3,0.3 c-0.2,0.2-0.4,0.5-0.5,0.7c-0.5,0.7-1,1.4-1.9,2.2c-1,0.8-2.4,0.6-3.1-0.4c-0.8-1-0.6-2.4,0.4-3.1c0.4-0.3,0.7-0.8,1-1.2 c0.2-0.3,0.4-0.6,0.7-1C636,870.8,637.4,869.9,639.1,869.8z"
})));

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M500,748.7l-17.2,16.8c-0.5,0.5-1.2,0.7-1.9,0.5c-0.7-0.2-1.2-0.8-1.4-1.4l-5.9-23.3c-0.2-0.7,0-1.4,0.6-1.9 c0.5-0.5,1.2-0.7,1.9-0.5l23.1,6.5c0.7,0.2,1.2,0.8,1.4,1.4S500.6,748.2,500,748.7z M482.5,760.1l12.2-11.9l-16.4-4.7L482.5,760.1z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M444.2,1181.3l-4.7,4.7c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0l4.7-4.7l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0l0,0 c0.9-0.9,0.9-2.2,0-3.1l-4.7-4.7l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7 c-0.9-0.9-2.2-0.9-3.1,0l0,0c-0.9,0.9-0.9,2.2,0,3.1L444.2,1181.3z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M398.5,747c-16.4,0-29.7-13.3-29.7-29.7s13.3-29.7,29.7-29.7c16.4,0,29.7,13.3,29.7,29.7S414.9,747,398.5,747z M398.5,697 c-11.2,0-20.3,9.1-20.3,20.3c0,11.2,9.1,20.3,20.3,20.3c11.2,0,20.3-9.1,20.3-20.3C418.8,706.1,409.6,697,398.5,697z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M227.1,895.2l5.6-33.5c0.2-1,0.9-1.8,1.8-2.2s2-0.2,2.8,0.5l26.1,21.5c0.8,0.7,1.1,1.6,1,2.7c-0.2,1-0.9,1.8-1.8,2.2 l-31.7,11.9c-1,0.4-2,0.2-2.8-0.5C227.3,897.2,227,896.1,227.1,895.2z M237.4,867.5l-4,23.8l22.6-8.5L237.4,867.5z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.7,923.8c0-4.1,3.3-7.3,7.3-7.3s7.3,3.3,7.3,7.3s-3.3,7.3-7.3,7.3S41.7,927.9,41.7,923.8z M54.1,923.8 c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5,2.3-5,5.1c0,2.8,2.3,5.1,5.1,5.1C51.9,928.8,54.1,926.6,54.1,923.8z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_4_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M589.2,1224.7c1.5,0.6,2.8,1.7,3.6,3.5c0.2,0.4,0.4,0.8,0.5,1.1c0.2,0.5,0.4,1,0.7,1.4c0.9,1.5,2.8,2.3,4.5,1.6 c0.5-0.2,1-0.5,1.6-0.8c0.2-0.1,0.3-0.2,0.5-0.3c2-1,3.8-1.2,5.4-0.7c1.6,0.6,3,1.9,3.8,4c0.1,0.2,0.2,0.5,0.3,0.7 c0.2,0.5,0.4,1,0.6,1.3c1,1.6,2.8,2.4,4.6,1.7c0.5-0.2,1-0.4,1.4-0.7c0.5-0.2,1-0.5,1.4-0.7c3.1-1.3,6.3-0.3,7.9,2.8 c0.3,0.6,0.6,1.1,0.8,1.7c0.2,0.5,0.4,1,0.7,1.4c0.6,1,0.2,2.4-0.9,3.1c-1,0.6-2.4,0.2-3.1-0.9c-0.4-0.7-0.6-1.2-0.9-1.8 c-0.2-0.5-0.4-1-0.6-1.3c-0.6-1-1.2-1.2-2.3-0.8c-0.4,0.2-0.8,0.4-1.1,0.6c-0.6,0.3-1.1,0.6-1.9,0.9c-3.8,1.4-8-0.1-10-3.6 c-0.4-0.6-0.6-1.1-0.9-1.7c-0.1-0.2-0.2-0.4-0.3-0.6c-0.4-0.9-0.9-1.4-1.2-1.6l0,0c-0.4-0.2-1,0-1.9,0.4c-0.2,0.1-0.3,0.2-0.5,0.2 c-0.6,0.3-1.3,0.7-2.1,1c-3.7,1.3-7.9-0.2-9.8-3.6c-0.4-0.7-0.6-1.2-0.9-1.8c-0.1-0.3-0.3-0.7-0.4-1c-0.7-1.4-1.4-1.6-2.8-1 c-0.3,0.1-0.5,0.3-0.8,0.4c-0.8,0.4-1.6,0.9-2.7,1c-1.2,0.3-2.4-0.5-2.7-1.7c-0.3-1.2,0.5-2.4,1.7-2.7c0.5-0.1,1-0.4,1.5-0.7 c0.3-0.2,0.7-0.4,1-0.5C586,1224.3,587.7,1224.2,589.2,1224.7z"
})));

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M553.6,994.7l25.1-48c1.7-3.2,5.7-4.5,8.9-2.8l0,0c3.2,1.7,4.5,5.7,2.8,8.9l-25.1,48c-1.7,3.2-5.7,4.5-8.9,2.8l0,0 C553.3,1002,552,998,553.6,994.7z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M514.2,1247.6c7.5-3.2,16.3,0.3,19.5,7.8c3.2,7.5-0.3,16.3-7.8,19.5c-7.5,3.2-16.3-0.3-19.5-7.8 C503.1,1259.6,506.7,1250.9,514.2,1247.6z M524,1270.6c5.1-2.2,7.5-8.2,5.3-13.3c-2.2-5.1-8.2-7.5-13.3-5.3 c-5.1,2.2-7.5,8.2-5.3,13.3C512.9,1270.4,518.9,1272.8,524,1270.6z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M431.5,1097.7l5.4,22.1c0.2,0.7,0,1.3-0.6,1.8c-0.5,0.5-1.1,0.7-1.8,0.5l-21.8-6.4c-0.7-0.2-1.1-0.7-1.3-1.3 c-0.2-0.7,0-1.3,0.6-1.8l16.4-15.7c0.5-0.5,1.1-0.7,1.8-0.5C431,1096.4,431.4,1097,431.5,1097.7z M432.5,1117.4l-3.8-15.7 l-11.7,11.2L432.5,1117.4z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_5_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M417.8,942.4c1.4,2.2,1.8,5,1.1,8c-0.1,0.7-0.3,1.2-0.4,1.9c-0.2,0.9-0.4,1.5-0.6,2.4c-0.4,2.8,1.2,5.5,4.1,6.4 c0.9,0.2,1.7,0.5,2.7,0.6c0.3,0.1,0.6,0.1,1,0.2c3.5,0.7,6,2.1,7.5,4.5c1.5,2.3,1.8,5.2,1,8.8c-0.1,0.4-0.2,0.8-0.3,1.1 c-0.2,0.8-0.4,1.5-0.6,2.2c-0.5,3,1.2,5.6,4.2,6.5c0.8,0.2,1.5,0.4,2.5,0.5c0.8,0.2,1.6,0.3,2.5,0.5c5.3,1.3,8.2,5.8,7.3,11.2 c-0.2,1-0.4,2-0.7,2.9c-0.2,0.9-0.4,1.6-0.5,2.5c-0.3,1.9-2,3.2-4,3s-3.2-2-3-4c0.1-1.1,0.4-2.1,0.7-3.1c0.2-0.8,0.4-1.5,0.6-2.2 c0.3-1.8-0.4-2.8-2.2-3.2c-0.6-0.2-1.2-0.3-2-0.4c-1-0.2-2.1-0.4-3.1-0.7c-6.2-1.9-10-7.9-9.2-14.3c0.2-1,0.5-2,0.6-3 c0.1-0.3,0.2-0.8,0.3-1c0.4-1.5,0.4-2.7-0.1-3.3l0,0c-0.4-0.6-1.4-1-3-1.3c-0.3-0.1-0.6-0.1-0.8-0.2c-1-0.2-2.3-0.4-3.6-0.9 c-6.1-1.9-9.7-7.8-8.9-14.1c0.1-1.1,0.5-2.2,0.7-3.1c0.2-0.6,0.3-1.1,0.4-1.5c0.5-2.5-0.1-3.3-2.5-3.9c-0.4-0.1-1-0.2-1.3-0.3 c-1.3-0.3-2.9-0.5-4.5-1.2c-1.7-0.9-2.5-3-1.7-4.8c0.9-1.7,3-2.5,4.8-1.7c0.7,0.3,1.5,0.5,2.5,0.6c0.6,0.1,1.2,0.2,1.7,0.3 C414.1,938.7,416.4,940.2,417.8,942.4z"
})));

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M208.3,1068.2l-3.1,5.9c-0.6,1-0.1,2.4,1,2.9l0,0c1,0.6,2.4,0.1,2.9-1l3.1-5.9l5.9,3.1c1,0.6,2.4,0.1,2.9-1l0,0 c0.6-1,0.1-2.4-1-2.9l-5.9-3.1l3.1-5.9c0.6-1,0.1-2.4-1-2.9l0,0c-1-0.6-2.4-0.1-2.9,1l-3.1,5.9l-5.9-3.1c-1-0.6-2.4-0.1-2.9,1l0,0 c-0.6,1-0.1,2.4,1,2.9L208.3,1068.2z"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M301.2,1089.2c7.9-2.5,16.3,1.9,18.8,9.7c2.5,7.9-1.9,16.3-9.7,18.8c-7.9,2.5-16.3-1.9-18.8-9.7 C288.9,1100.1,293.3,1091.8,301.2,1089.2z M308.8,1113.3c5.3-1.7,8.4-7.4,6.7-12.9c-1.7-5.3-7.4-8.4-12.9-6.7 c-5.3,1.7-8.4,7.4-6.7,12.9C297.7,1112,303.4,1114.9,308.8,1113.3z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M496,1058.6l-3.1,5.9c-0.6,1-0.1,2.4,1,2.9l0,0c1,0.6,2.4,0.1,2.9-1l3.1-5.9l5.9,3.1c1,0.6,2.4,0.1,2.9-1l0,0 c0.6-1,0.1-2.4-1-2.9l-5.9-3.1l3.1-5.9c0.6-1,0.1-2.4-1-2.9l0,0c-1-0.6-2.4-0.1-2.9,1l-3.1,5.9l-5.9-3.1c-1-0.6-2.4-0.1-2.9,1l0,0 c-0.6,1-0.1,2.4,1,2.9L496,1058.6z"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M329,924.2c3.9-1.2,8,1,9.2,4.8c1.2,3.9-1,8-4.8,9.2c-3.9,1.2-8-1-9.2-4.8C322.9,929.5,325.1,925.3,329,924.2z M332.7,936 c2.7-0.9,4.1-3.6,3.2-6.3s-3.6-4.1-6.3-3.2c-2.7,0.9-4.1,3.6-3.2,6.3C327.1,935.2,330,936.8,332.7,936z"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M417.1,1261.7l-36.3,6.6c-1,0.2-2.2-0.2-2.9-1c-0.7-0.9-1-2-0.6-3.1l12.5-34.8c0.4-1,1.2-1.8,2.4-2c1-0.2,2.2,0.2,2.9,1 l23.9,28.1c0.7,0.9,1,2,0.6,3.1C419.1,1260.8,418.3,1261.5,417.1,1261.7z M384.9,1261.3l25.8-4.7l-17-20L384.9,1261.3z"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M585.2,1050.2c3.9-1.2,8,1,9.2,4.8c1.2,3.9-1,8-4.8,9.2c-3.9,1.2-8-1-9.2-4.8C579.1,1055.5,581.3,1051.4,585.2,1050.2z M588.9,1062c2.7-0.9,4.1-3.6,3.2-6.3c-0.9-2.7-3.6-4.1-6.3-3.2c-2.7,0.9-4.1,3.6-3.2,6.3C583.4,1061.4,586.2,1062.9,588.9,1062z"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M579.4,798.3l-5.1-4.3c-0.9-0.8-2.3-0.7-3.1,0.3l0,0c-0.8,0.9-0.7,2.3,0.3,3.1l5.1,4.3l-4.3,5.1c-0.8,0.9-0.7,2.3,0.3,3.1 l0,0c0.9,0.8,2.3,0.7,3.1-0.3l4.3-5.1l5.1,4.3c0.9,0.8,2.3,0.7,3.1-0.3l0,0c0.8-0.9,0.7-2.3-0.3-3.1l-5.1-4.3l4.3-5.1 c0.8-0.9,0.7-2.3-0.3-3.1l0,0c-0.9-0.8-2.3-0.7-3.1,0.3L579.4,798.3z"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M234.6,1284.5l18.3-13.5c0.6-0.4,1.2-0.5,1.9-0.2c0.7,0.3,1,0.9,1.1,1.5l2.6,22.6c0.1,0.7-0.2,1.3-0.8,1.7 c-0.6,0.4-1.2,0.5-1.9,0.2l-20.9-9.1c-0.7-0.3-1-0.9-1.1-1.5C233.7,1285.6,234,1284.9,234.6,1284.5z M252.4,1276l-13.1,9.6l14.9,6.5 L252.4,1276z"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M208.6,950.3c3.1,7.6-0.6,16.4-8.3,19.5c-7.6,3.1-16.4-0.6-19.5-8.3c-3.1-7.6,0.6-16.4,8.3-19.5 C196.6,939,205.4,942.6,208.6,950.3z M185.2,959.7c2.1,5.2,8.1,7.7,13.3,5.6c5.2-2.1,7.7-8.1,5.6-13.3c-2.1-5.2-8.1-7.7-13.3-5.6 C185.6,948.6,183,954.6,185.2,959.7z"
});

var _ref40 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_6_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M694.8,534.6c1.1-0.1,2.3,0.3,3.3,1.1c0.2,0.2,0.5,0.4,0.7,0.6c0.3,0.3,0.6,0.5,0.9,0.7c1,0.7,2.4,0.6,3.3-0.4 c0.3-0.3,0.5-0.6,0.8-1c0.1-0.1,0.2-0.2,0.2-0.3c1-1.2,2-1.9,3.2-2.1c1.2-0.1,2.4,0.3,3.6,1.3c0.1,0.1,0.3,0.2,0.4,0.4 c0.3,0.2,0.6,0.5,0.8,0.7c1,0.8,2.5,0.6,3.3-0.4c0.2-0.3,0.5-0.6,0.7-0.9c0.2-0.3,0.5-0.6,0.7-0.9c1.6-1.8,3.9-2.1,5.8-0.8 c0.4,0.3,0.7,0.6,1,0.9c0.3,0.3,0.6,0.5,0.9,0.7c0.7,0.5,0.9,1.4,0.4,2.2c-0.5,0.7-1.4,0.9-2.2,0.4c-0.4-0.3-0.8-0.6-1.1-0.9 c-0.3-0.2-0.6-0.5-0.8-0.7c-0.7-0.5-1.1-0.4-1.7,0.2c-0.2,0.2-0.4,0.5-0.6,0.7c-0.3,0.4-0.6,0.8-1,1.1c-2,2.1-5.1,2.4-7.4,0.8 c-0.4-0.3-0.8-0.6-1-0.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.5-1-0.7-1.3-0.7l0,0c-0.3,0-0.7,0.4-1,0.9c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.3,0.4-0.7,0.9-1,1.2c-1.9,2-5.1,2.3-7.3,0.8c-0.4-0.3-0.8-0.6-1.1-0.9c-0.2-0.2-0.4-0.3-0.6-0.5c-0.9-0.7-1.3-0.6-2,0.2 c-0.1,0.2-0.2,0.3-0.4,0.5c-0.4,0.5-0.8,1-1.3,1.5c-0.7,0.6-1.6,0.4-2.2-0.3c-0.6-0.7-0.4-1.6,0.3-2.2c0.3-0.2,0.5-0.5,0.8-0.9 c0.2-0.2,0.3-0.4,0.5-0.7C692.7,535.3,693.8,534.7,694.8,534.6z"
})));

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M637.5,587.4c0-4.1,3.3-7.5,7.5-7.5c4.1,0,7.5,3.3,7.5,7.5c0,4.2-3.3,7.5-7.5,7.5C641,594.9,637.5,591.6,637.5,587.4z M650.2,587.4c0-2.9-2.3-5.1-5.1-5.1c-2.9,0-5.1,2.3-5.1,5.1c0,2.9,2.3,5.1,5.1,5.1S650.2,590.2,650.2,587.4z"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M427.4,901.1l1.8-3.3c0.3-0.6,0.1-1.3-0.5-1.6l0,0c-0.6-0.3-1.3-0.1-1.6,0.5l-1.8,3.3l-3.3-1.8c-0.6-0.3-1.3-0.1-1.6,0.5 l0,0c-0.3,0.6-0.1,1.3,0.5,1.6l3.3,1.8l-1.8,3.3c-0.3,0.6-0.1,1.3,0.5,1.6l0,0c0.6,0.3,1.3,0.1,1.6-0.5l1.8-3.3l3.3,1.8 c0.6,0.3,1.3,0.1,1.6-0.5l0,0c0.3-0.6,0.1-1.3-0.5-1.6L427.4,901.1z"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M558.7,876.8c3.6-3,9-2.5,12,1c3,3.6,2.5,9-1,12c-3.6,3-9,2.5-12-1C554.6,885.2,555.1,879.8,558.7,876.8z M567.9,887.8 c2.5-2,2.8-5.7,0.8-8.2c-2-2.5-5.7-2.8-8.2-0.8c-2.5,2-2.8,5.7-0.8,8.2S565.4,889.9,567.9,887.8z"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M500.5,867.7l-3.2-12.6c-0.1-0.4,0-0.8,0.3-1c0.3-0.3,0.7-0.4,1-0.3l12.5,3.5c0.4,0.1,0.7,0.4,0.8,0.8c0.1,0.4,0,0.8-0.3,1 l-9.3,9.2c-0.3,0.3-0.7,0.4-1,0.3C500.8,868.4,500.6,868.1,500.5,867.7z M499.8,856.4l2.3,9l6.6-6.5L499.8,856.4z"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M411.4,813.1c3.9-2.7,9.2-1.6,11.9,2.3c2.7,3.9,1.6,9.2-2.3,11.9c-3.9,2.7-9.2,1.6-11.9-2.3 C406.6,821.1,407.5,815.8,411.4,813.1z M419.5,825c2.7-1.8,3.3-5.4,1.5-8.1c-1.8-2.7-5.4-3.3-8.1-1.5c-2.7,1.8-3.3,5.4-1.5,8.1 C413.2,826.2,416.9,826.8,419.5,825z"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M508.7,938.5l-18.9,9.5c-0.6,0.3-1.2,0.3-1.7-0.1c-0.6-0.4-0.9-1-0.8-1.5l1.1-21.1c0-0.7,0.4-1.1,1-1.4s1.2-0.3,1.7,0.1 l17.7,11.5c0.6,0.4,0.9,1,0.8,1.5C509.7,937.6,509.3,938.2,508.7,938.5z M491.1,943.5l13.4-6.8l-12.6-8.2L491.1,943.5z"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M519,819.3l-28.5-5.8c-1.9-0.4-3.1-2.3-2.8-4.2l0,0c0.4-1.9,2.3-3.1,4.2-2.8l28.5,5.8c1.9,0.4,3.1,2.3,2.8,4.2l0,0 C522.9,818.5,521,819.7,519,819.3z"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M639.9,642.9l-13.5,11.1c-0.9,0.8-2.3,0.6-3-0.3l0,0c-0.8-0.9-0.6-2.3,0.3-3l13.5-11.1c0.9-0.8,2.3-0.6,3,0.3l0,0 C641,640.8,640.9,642.1,639.9,642.9z"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159.5,1142.6l8-27.9c0.6-1.9,2.5-3,4.4-2.4l0,0c1.9,0.6,3,2.5,2.4,4.4l-8,27.9c-0.6,1.9-2.5,3-4.4,2.4l0,0 C160,1146.4,158.9,1144.5,159.5,1142.6z"
});

var _ref50 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_7_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M344.4,1179.8c0.7-0.9,1.8-1.4,3.1-1.5c0.3,0,0.6-0.1,0.9-0.1c0.4,0,0.8,0,1-0.1c1.2-0.2,2.1-1.3,2.1-2.6 c0-0.4-0.1-0.8-0.1-1.2c0-0.1,0-0.3-0.1-0.4c-0.2-1.5,0.1-2.8,0.9-3.7c0.8-1,1.9-1.4,3.5-1.6c0.2,0,0.4,0,0.6,0c0.4,0,0.7,0,1-0.1 c1.3-0.2,2.2-1.3,2.2-2.6c0-0.4-0.1-0.7-0.1-1c-0.1-0.4-0.1-0.8-0.1-1.1c-0.2-2.4,1.3-4.2,3.7-4.6c0.5-0.1,0.9-0.1,1.3-0.1 c0.4,0,0.8-0.1,1-0.1c0.9-0.2,1.6,0.4,1.8,1.2c0.2,0.9-0.4,1.6-1.2,1.8c-0.5,0.1-1,0.1-1.4,0.2c-0.4,0-0.7,0-1,0.1 c-0.8,0.1-1.1,0.6-1,1.3c0,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.1,1,0.1,1.4c0.1,2.9-1.9,5.2-4.8,5.7c-0.5,0.1-1,0.1-1.3,0.1 c-0.2,0-0.3,0-0.5,0c-0.7,0.1-1.1,0.2-1.3,0.5l0,0c-0.2,0.2-0.3,0.8-0.2,1.3c0,0.1,0,0.3,0,0.4c0.1,0.5,0.1,1,0.1,1.6 c0,2.8-2,5.1-4.7,5.6c-0.5,0.1-1,0.1-1.4,0.1c-0.3,0-0.5,0-0.7,0.1c-1,0.1-1.4,0.6-1.3,1.6c0,0.2,0.1,0.4,0.1,0.6 c0.1,0.6,0.2,1.2,0.1,2c-0.1,0.9-0.9,1.4-1.7,1.3c-0.9-0.1-1.4-0.9-1.3-1.7c0-0.3,0-0.7-0.1-1.1c0-0.3-0.1-0.5-0.1-0.8 C343.4,1181.8,343.6,1180.7,344.4,1179.8z"
})));

var _ref51 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_8_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M659.4,1008.9c2.8,1,4.9,3.2,6.3,6.6c0.4,0.8,0.6,1.4,0.9,2c0.3,1,0.7,1.7,1.2,2.6c1.4,2.9,4.9,4.1,8.1,3.1 c1-0.3,1.9-0.8,3-1.2c0.3-0.2,0.6-0.3,1-0.5c3.6-1.8,6.9-2.1,9.8-1s5.1,3.6,6.9,7.4c0.2,0.5,0.4,0.8,0.6,1.2c0.3,1,0.7,1.7,1,2.5 c1.6,3,5,4.3,8.2,3.2c1-0.3,1.7-0.7,2.6-1.2c0.8-0.4,1.6-1,2.6-1.2c5.8-2.3,11.4-0.4,14.4,5.2c0.6,1,1,2.1,1.3,3.1 s0.7,1.7,1.2,2.6c1.1,1.9,0.3,4.4-1.6,5.3c-1.9,1.1-4.4,0.3-5.3-1.6c-0.6-1-1-2.3-1.6-3.3c-0.4-0.8-0.7-1.7-1-2.5 c-1-1.9-2.3-2.3-4.1-1.5c-0.7,0.2-1.3,0.7-2.1,1c-1,0.5-2.1,1-3.5,1.5c-6.9,2.5-14.5-0.5-17.9-6.9c-0.6-1-1-2.1-1.4-3.2 c-0.2-0.5-0.4-0.8-0.4-1.1c-0.7-1.7-1.5-2.7-2.4-3l0,0c-0.9-0.3-1.9,0-3.4,0.8c-0.2,0.1-0.6,0.3-0.8,0.4c-1,0.6-2.3,1.1-3.8,1.7 c-6.8,2.3-14.2-0.6-17.5-6.9c-0.6-1-1.1-2.3-1.6-3.3c-0.3-0.6-0.4-1.1-0.7-1.7c-1.2-2.6-2.5-3.1-5-2c-0.5,0.2-1,0.5-1.3,0.7 c-1.3,0.7-2.9,1.4-4.9,1.9c-2.2,0.5-4.3-1-4.8-3.2c-0.5-2.2,1-4.3,3.2-4.8c0.9-0.2,1.7-0.7,2.7-1.1c0.6-0.3,1-0.6,1.9-1 C653.6,1007.9,656.7,1007.7,659.4,1008.9z"
})));

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.4,1165.8c3.9-2.7,9.2-1.6,11.9,2.3c2.7,3.9,1.6,9.2-2.3,11.9c-3.9,2.7-9.2,1.6-11.9-2.3 C647.5,1173.8,648.5,1168.5,652.4,1165.8z M660.5,1177.7c2.7-1.8,3.3-5.4,1.5-8.1c-1.8-2.7-5.4-3.3-8.1-1.5 c-2.7,1.8-3.3,5.4-1.5,8.1C654.2,1178.9,657.8,1179.6,660.5,1177.7z"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M501.5,1136.1l-3.2-12.6c-0.1-0.4,0-0.8,0.3-1c0.3-0.3,0.7-0.4,1-0.3l12.5,3.5c0.4,0.1,0.7,0.4,0.8,0.8c0.1,0.4,0,0.8-0.3,1 l-9.3,9.2c-0.3,0.3-0.7,0.4-1,0.3C501.9,1136.8,501.6,1136.5,501.5,1136.1z M500.8,1124.7l2.3,9l6.6-6.5L500.8,1124.7z"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M414.5,1049.6l-41.3,10.7c-2.8,0.7-5.6-1-6.3-3.7l0,0c-0.7-2.8,1-5.6,3.7-6.3l41.3-10.7c2.8-0.7,5.6,1,6.3,3.7l0,0 C418.9,1046.1,417.2,1048.9,414.5,1049.6z"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M334.5,1022.1l-3.2-12.6c-0.1-0.4,0-0.8,0.3-1c0.3-0.3,0.7-0.4,1-0.3l12.5,3.5c0.4,0.1,0.7,0.4,0.8,0.8c0.1,0.4,0,0.8-0.3,1 l-9.3,9.2c-0.3,0.3-0.7,0.4-1,0.3C334.9,1022.7,334.6,1022.5,334.5,1022.1z M333.8,1010.7l2.3,9l6.6-6.5L333.8,1010.7z"
});

var _ref56 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_9_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M285.3,1008.2c-1.7,0.5-3.6,0.2-5.6-0.9c-0.4-0.2-0.9-0.5-1.1-0.8c-0.6-0.3-1-0.6-1.5-0.9c-1.8-0.9-4-0.3-5.1,1.4 c-0.4,0.5-0.7,1.1-1,1.7c-0.1,0.2-0.2,0.4-0.3,0.6c-1.1,2.2-2.8,3.6-4.6,4.1c-1.9,0.5-3.9,0.1-6.1-1.2c-0.3-0.2-0.5-0.3-0.8-0.5 c-0.5-0.3-1-0.6-1.4-0.9c-1.9-1-4.1-0.3-5.2,1.4c-0.3,0.5-0.6,1-0.9,1.5c-0.3,0.6-0.5,1-0.9,1.6c-2,3.3-5.6,4.4-9.2,2.7 c-0.7-0.4-1.2-0.7-1.8-1c-0.6-0.3-1-0.6-1.5-0.9c-1.2-0.6-1.8-2.1-1.2-3.3c0.6-1.2,2.1-1.8,3.3-1.2c0.8,0.4,1.3,0.8,2,1 c0.5,0.3,1,0.6,1.4,0.9c1.1,0.6,2,0.4,2.7-0.8c0.2-0.4,0.5-0.9,0.7-1.2c0.4-0.7,0.8-1.3,1.1-2c2.6-3.8,7.4-5.1,11.6-3.1 c0.8,0.3,1.3,0.8,1.9,1c0.2,0.1,0.5,0.3,0.6,0.4c1,0.6,1.7,0.9,2.2,0.7l0,0c0.5-0.2,1-0.7,1.5-1.6c0.1-0.2,0.2-0.4,0.3-0.6 c0.4-0.7,0.8-1.4,1.3-2.3c2.6-3.7,7.3-5.1,11.4-3.1c0.8,0.4,1.3,0.8,2,1.1c0.3,0.2,0.7,0.4,1,0.6c1.5,0.9,2.4,0.7,3.2-0.9 c0.2-0.3,0.3-0.6,0.5-0.9c0.4-0.9,0.9-1.8,1.8-2.8s2.5-1.1,3.5-0.2c1,1,1.1,2.5,0.2,3.5c-0.4,0.4-0.7,1-1,1.6 c-0.2,0.4-0.4,0.8-0.6,1.1C288.6,1006.4,287.1,1007.7,285.3,1008.2z"
})));

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M242.4,807.1l-18.6,26.6c-1.3,1.8-3.7,2.2-5.5,1l0,0c-1.8-1.3-2.2-3.7-1-5.5l18.6-26.6c1.3-1.8,3.7-2.2,5.5-1l0,0 C243.1,802.8,243.5,805.2,242.4,807.1z"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M258.5,610.5l-12.7-21.3c-0.4-0.6-0.4-1.4,0-2.1c0.3-0.6,1-1.1,1.8-1.1l24.8-0.3c0.7,0,1.4,0.4,1.8,1s0.4,1.4,0,2.1 L262,610.4c-0.3,0.6-1,1.1-1.8,1.1C259.5,611.6,258.8,611.2,258.5,610.5z M251.1,590.2l9,15.2l8.6-15.3L251.1,590.2z"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M316.7,747.6l5.8,3.2c1.1,0.6,2.3,0.2,2.9-0.8l0,0c0.6-1.1,0.2-2.3-0.8-2.9l-5.8-3.2l3.2-5.8c0.6-1.1,0.2-2.3-0.8-2.9l0,0 c-1.1-0.6-2.3-0.2-2.9,0.8l-3.2,5.8l-5.8-3.2c-1.1-0.6-2.3-0.2-2.9,0.8l0,0c-0.6,1.1-0.2,2.3,0.8,2.9l5.8,3.2l-3.2,5.8 c-0.6,1.1-0.2,2.3,0.8,2.9l0,0c1.1,0.6,2.3,0.2,2.9-0.8L316.7,747.6z"
});

var _ref60 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_13_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M210.5,531.3c1.5-0.6,3.2-0.5,5,0.3c0.4,0.2,0.8,0.4,1.1,0.5c0.5,0.3,0.9,0.4,1.5,0.6c1.7,0.6,3.5-0.2,4.5-1.8 c0.3-0.5,0.5-1,0.7-1.6c0-0.2,0.1-0.3,0.2-0.6c0.8-2.1,2-3.4,3.6-4.1s3.4-0.5,5.6,0.4c0.2,0.1,0.4,0.2,0.7,0.3 c0.5,0.3,0.9,0.4,1.4,0.6c1.8,0.6,3.6-0.1,4.5-1.8c0.3-0.5,0.4-0.9,0.6-1.5c0.2-0.4,0.3-1,0.6-1.5c1.5-3.1,4.5-4.4,7.8-3.3 c0.7,0.2,1.2,0.4,1.7,0.7c0.5,0.3,0.9,0.4,1.5,0.6c1.2,0.4,1.8,1.7,1.4,2.8c-0.4,1.2-1.7,1.8-2.8,1.4c-0.7-0.2-1.2-0.5-1.9-0.8 c-0.4-0.2-0.9-0.4-1.4-0.6c-1.1-0.4-1.8-0.1-2.2,0.9c-0.2,0.4-0.3,0.8-0.4,1.2c-0.2,0.6-0.4,1.2-0.8,1.9c-1.9,3.6-6,5.3-9.9,4 c-0.7-0.2-1.2-0.4-1.8-0.8c-0.2-0.1-0.4-0.2-0.6-0.3c-0.9-0.4-1.6-0.5-2.1-0.3l0,0c-0.4,0.2-0.8,0.7-1.1,1.6 c-0.1,0.1-0.1,0.3-0.2,0.4c-0.2,0.7-0.5,1.3-0.9,2.1c-1.9,3.5-6,5.2-9.7,3.8c-0.7-0.2-1.3-0.5-1.9-0.8c-0.3-0.1-0.6-0.3-0.9-0.4 c-1.5-0.6-2.2-0.3-2.8,1.1c-0.1,0.2-0.2,0.6-0.3,0.8c-0.3,0.8-0.6,1.7-1.2,2.6c-0.7,1-2.1,1.2-3.1,0.5c-1-0.7-1.2-2.1-0.5-3.1 c0.3-0.4,0.4-0.9,0.7-1.5c0.1-0.3,0.2-0.7,0.4-1.1C207.8,533,208.9,531.8,210.5,531.3z"
})));

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.8,899l-3.2,5.8c-0.6,1.1-0.2,2.3,0.8,2.9l0,0c1.1,0.6,2.3,0.2,2.9-0.8l3.2-5.8l5.8,3.2c1.1,0.6,2.3,0.2,2.9-0.8l0,0 c0.6-1.1,0.2-2.3-0.8-2.9l-5.8-3.2l3.2-5.8c0.6-1.1,0.2-2.3-0.8-2.9l0,0c-1.1-0.6-2.3-0.2-2.9,0.8l-3.2,5.8l-5.8-3.2 c-1.1-0.6-2.3-0.2-2.9,0.8l0,0c-0.6,1.1-0.2,2.3,0.8,2.9L138.8,899z"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162.3,674.7l11-53.1c0.8-3.6,4.3-5.9,7.8-5.1l0,0c3.6,0.8,5.9,4.3,5.1,7.8l-11,53.1c-0.8,3.6-4.3,5.9-7.8,5.1l0,0 C163.9,681.7,161.6,678.2,162.3,674.7z"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.8,843l11.3,19.8c0.4,0.6,0.4,1.3-0.1,1.9c-0.3,0.6-0.9,1-1.6,1l-22.7-0.2c-0.7,0-1.3-0.3-1.6-0.9 c-0.4-0.6-0.4-1.3,0.1-1.9L85.6,843c0.3-0.6,0.9-1,1.6-1C87.9,842,88.6,842.4,88.8,843z M95.1,861.7l-8-14.1l-8.2,13.9L95.1,861.7z"
});

var _ref64 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_12_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M33.3,697.3c2,1.7,3.1,4.3,3.3,7.4c0.1,0.7,0.1,1.3,0.2,1.9c0.1,0.9,0,1.6,0.1,2.4c0.4,2.8,2.7,5,5.7,5 c0.9-0.1,1.8,0,2.7-0.2c0.3,0,0.6-0.1,1-0.1c3.6-0.3,6.3,0.4,8.5,2.3c2.1,1.8,3.2,4.6,3.3,8.2c0,0.4,0,0.8,0,1.2 c0,0.8,0,1.6,0,2.3c0.3,3,2.7,5.1,5.8,5.1c0.8,0,1.6,0,2.5-0.2c0.8,0,1.6-0.2,2.5-0.2c5.5-0.2,9.5,3.4,10.1,8.7 c0.1,1.1,0.2,2,0.1,2.9c0.1,0.9,0.1,1.7,0.2,2.5c0.2,1.9-1,3.7-3,3.9c-2,0.3-3.7-1-3.9-3c-0.2-1.1-0.2-2.1-0.2-3.2 c0-0.8,0-1.6,0-2.3c-0.2-1.8-1.1-2.6-3-2.5c-0.6,0-1.3,0.1-2,0.2c-1.1,0.1-2.1,0.2-3.2,0.2c-6.5-0.1-11.8-4.9-12.7-11.3 c-0.1-1.1-0.1-2.1-0.3-3c0-0.3,0-0.8,0-1c0-1.6-0.4-2.7-1-3.2l0,0c-0.5-0.4-1.7-0.6-3.2-0.5c-0.3,0-0.6,0.1-0.8,0 c-1.1,0.1-2.3,0.3-3.7,0.2c-6.4-0.2-11.5-4.9-12.4-11.2c-0.2-1.1-0.1-2.2-0.2-3.2c0-0.6,0-1.2,0-1.6c-0.2-2.5-1-3.2-3.4-3.1 c-0.4,0-1,0.1-1.4,0.1c-1.4,0.1-2.9,0.3-4.6,0c-1.9-0.4-3.2-2.2-2.9-4.1c0.4-1.9,2.2-3.2,4.1-2.9c0.7,0.1,1.6,0,2.5-0.1 c0.6-0.1,1.2-0.2,1.7-0.2C28.7,694.7,31.4,695.6,33.3,697.3z"
})));

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.2,751.8l-1.3,6.5c-0.3,1.2,0.6,2.3,1.7,2.5l0,0c1.2,0.3,2.3-0.6,2.5-1.7l1.3-6.5l6.5,1.3c1.2,0.3,2.3-0.6,2.5-1.7l0,0 c0.3-1.2-0.6-2.3-1.7-2.5l-6.5-1.3l1.3-6.5c0.3-1.2-0.6-2.3-1.7-2.5l0,0c-1.2-0.3-2.3,0.6-2.5,1.7l-1.3,6.5l-6.5-1.3 c-1.2-0.3-2.3,0.6-2.5,1.7l0,0c-0.3,1.2,0.6,2.3,1.7,2.5L124.2,751.8z"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M207.8,719.5c3.4-2.3,8-1.3,10.2,2.1c2.3,3.4,1.3,8-2.1,10.2c-3.4,2.3-8,1.3-10.2-2.1C203.3,726.3,204.3,721.7,207.8,719.5z M214.6,729.8c2.3-1.6,3-4.6,1.4-6.9c-1.6-2.3-4.6-3-6.9-1.4c-2.3,1.6-3,4.6-1.4,6.9C209.1,730.7,212.2,731.4,214.6,729.8z"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.6,478.7l-6-2.8c-1-0.5-2.4,0-2.9,1.1l0,0c-0.5,1,0,2.4,1.1,2.9l6,2.8l-2.8,6c-0.5,1,0,2.4,1.1,2.9l0,0 c1,0.5,2.4,0,2.9-1.1l2.8-6l6,2.8c1,0.5,2.4,0,2.9-1.1l0,0c0.5-1,0-2.4-1.1-2.9l-6-2.8l2.8-6c0.5-1,0-2.4-1.1-2.9l0,0 c-1-0.5-2.4,0-2.9,1.1L133.6,478.7z"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.4,655l0.8-3.7c0.1-0.6-0.3-1.3-0.9-1.4l0,0c-0.6-0.1-1.3,0.3-1.4,0.9l-0.8,3.7l-3.7-0.8c-0.6-0.1-1.3,0.3-1.4,0.9l0,0 c-0.1,0.6,0.3,1.3,0.9,1.4l3.7,0.8l-0.8,3.7c-0.1,0.6,0.3,1.3,0.9,1.4l0,0c0.6,0.1,1.3-0.3,1.4-0.9l0.8-3.7l3.7,0.8 c0.6,0.1,1.3-0.3,1.4-0.9l0,0c0.1-0.6-0.3-1.3-0.9-1.4L31.4,655z"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135,559.8c2.7-3.8,7.9-4.8,11.8-2.3c3.8,2.7,4.8,7.9,2.3,11.8c-2.7,3.8-7.9,4.8-11.8,2.3C133.4,569,132.4,563.8,135,559.8z M146.8,567.9c1.8-2.6,1.1-6.3-1.5-8.1c-2.6-1.8-6.3-1.1-8.1,1.5c-1.8,2.6-1.1,6.3,1.5,8.1C141.3,571.2,145,570.6,146.8,567.9z"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.5,567L70,555.8c-0.2-0.3-0.2-0.7,0-1.1c0.2-0.4,0.5-0.5,0.9-0.6l13,0c0.4,0,0.7,0.2,0.9,0.5s0.2,0.7,0,1.1l-6.5,11.3 c-0.2,0.4-0.5,0.5-0.9,0.6C77.1,567.5,76.7,567.3,76.5,567z M72.8,556.3l4.6,8l4.6-8L72.8,556.3z"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.8,632.8l-15.6,14.3c-0.5,0.4-1.1,0.6-1.7,0.4c-0.7-0.2-1.1-0.7-1.1-1.3l-4.6-20.6c-0.2-0.6,0.1-1.2,0.5-1.6 c0.5-0.4,1.1-0.6,1.7-0.4l20.2,6.3c0.7,0.2,1.1,0.7,1.1,1.3C104.5,631.7,104.2,632.4,103.8,632.8z M88.2,642.4l11.1-10.2l-14.3-4.5 L88.2,642.4z"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.2,515.3l-29,2.2c-1.9,0.2-3.6-1.3-3.8-3.3l0,0c-0.2-1.9,1.3-3.6,3.3-3.8l29-2.2c1.9-0.2,3.6,1.3,3.8,3.3l0,0 C84.7,513.5,83.2,515.2,81.2,515.3z"
});

var _ref73 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_10_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M267.9,659.5c2.9,0.3,5.6,1.8,7.8,4.6c0.6,0.6,0.9,1.2,1.4,1.7c0.5,0.8,1.1,1.5,1.9,2.1c2.2,2.4,5.8,2.6,8.7,0.8 c0.8-0.5,1.6-1.3,2.5-2c0.2-0.3,0.5-0.4,0.9-0.7c3-2.7,6-3.9,9.2-3.6c3.2,0.3,5.9,2.1,8.6,5.3c0.3,0.4,0.6,0.6,0.9,1 c0.5,0.8,1.1,1.5,1.7,2.1c2.4,2.4,5.9,2.8,8.8,0.9c0.8-0.5,1.5-1.1,2.1-1.9c0.6-0.6,1.3-1.4,2.1-1.9c5-3.8,10.9-3.5,15.3,1.1 c0.8,0.9,1.6,1.7,2.1,2.6c0.5,0.8,1.1,1.5,1.9,2.1c1.6,1.5,1.5,4.1-0.1,5.6c-1.5,1.6-4.1,1.5-5.6-0.1c-0.8-0.9-1.5-1.9-2.5-2.8 c-0.6-0.6-1.1-1.5-1.7-2.1c-1.4-1.6-2.8-1.6-4.4-0.4c-0.6,0.4-1.1,1-1.7,1.6c-0.9,0.7-1.7,1.6-3,2.4c-5.9,4.3-14.1,3.5-19.1-1.7 c-0.8-0.9-1.6-1.7-2.3-2.7c-0.3-0.4-0.6-0.6-0.7-1c-1.1-1.5-2.2-2.2-3.1-2.2l0,0c-0.9,0-1.8,0.5-3.1,1.7c-0.2,0.1-0.5,0.4-0.6,0.6 c-0.9,0.8-1.9,1.7-3.2,2.7c-5.9,4-13.8,3.3-18.7-1.8c-0.8-0.9-1.7-1.9-2.5-2.8c-0.4-0.5-0.7-1-1.1-1.5c-1.9-2.1-3.2-2.3-5.3-0.6 c-0.4,0.3-0.9,0.7-1.1,1c-1.1,1-2.4,2.2-4.2,3.2c-2,1.1-4.4,0.2-5.5-1.8c-1.1-2-0.2-4.4,1.8-5.5c0.8-0.4,1.5-1.1,2.3-1.8 c0.5-0.4,0.9-0.8,1.6-1.4C262.1,660.1,265,659.1,267.9,659.5z"
})));

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M303.9,812.4c3-3.6,8.5-4.1,12.1-1c3.6,3,4.1,8.5,1,12.1c-3,3.6-8.5,4.1-12.1,1C301.4,821.5,300.9,816.1,303.9,812.4z M315,821.7c2.1-2.5,1.7-6.1-0.7-8.2c-2.5-2.1-6.1-1.7-8.2,0.7s-1.7,6.1,0.7,8.2C309.2,824.5,312.9,824.2,315,821.7z"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M150.6,824.9l-6.5-11.2c-0.2-0.3-0.2-0.7,0-1.1c0.2-0.4,0.5-0.5,0.9-0.6l13,0c0.4,0,0.7,0.2,0.9,0.5c0.2,0.3,0.2,0.7,0,1.1 l-6.5,11.3c-0.2,0.4-0.5,0.5-0.9,0.6C151.2,825.4,150.8,825.2,150.6,824.9z M146.9,814.2l4.6,8l4.6-8L146.9,814.2z"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.3,801.4l-36.8,21.5c-2.5,1.4-5.7,0.6-7.1-1.9l0,0c-1.4-2.5-0.6-5.7,1.9-7.1l36.8-21.5c2.5-1.4,5.7-0.6,7.1,1.9l0,0 C62.7,796.8,61.8,799.9,59.3,801.4z"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M232.3,400l90.1-23.8c2.6-0.7,5.5,0,7.4,1.9s2.6,4.8,1.9,7.4l-24.3,89.8c-0.7,2.6-2.9,4.8-5.5,5.5c-2.6,0.7-5.5,0-7.4-1.9 l-65.6-66c-1.9-1.9-2.6-4.8-1.9-7.4C227.5,402.6,229.7,400.7,232.3,400z M313.2,394.4l-64.1,17.1l46.6,47.1L313.2,394.4z"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M372.6,156.5l10.8-53.1c0.8-3.5,4.2-5.9,7.8-5.1l0,0c3.5,0.8,5.9,4.2,5.1,7.8l-10.8,53.1c-0.8,3.5-4.2,5.9-7.8,5.1l0,0 C374.2,163.6,371.9,160.1,372.6,156.5z"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M618.3,443l23.9-6.4c0.7-0.2,1.4,0,2,0.6c0.5,0.5,0.8,1.2,0.6,2l-6.5,23.9c-0.2,0.7-0.8,1.2-1.4,1.4c-0.7,0.2-1.4,0-2-0.6 l-17.4-17.5c-0.5-0.5-0.8-1.2-0.6-2C616.9,443.6,617.5,443.1,618.3,443z M639.8,441.4l-17.1,4.5l12.4,12.5L639.8,441.4z"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M226.3,327.9l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0l0,0c0.9-0.9,0.9-2.2,0-3.1l-4.7-4.7l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0 c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7c-0.9-0.9-2.2-0.9-3.1,0l0,0c-0.9,0.9-0.9,2.2,0,3.1l4.7,4.7l-4.7,4.7 c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0L226.3,327.9z"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M682.2,6.4l33.5,5.6c1,0.2,1.8,0.9,2.2,1.8c0.4,1,0.2,2-0.5,2.8l-21.5,26.1c-0.7,0.8-1.6,1.1-2.7,1c-1-0.2-1.8-0.9-2.2-1.8 l-11.9-31.7c-0.4-1-0.2-2,0.5-2.8C680.2,6.6,681.3,6.3,682.2,6.4z M710,16.7l-23.8-4l8.5,22.6L710,16.7z"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  d: "M397.6,326c4.1,0,7.3,3.3,7.3,7.3c0,4-3.3,7.3-7.3,7.3c-4,0-7.3-3.3-7.3-7.3C390.3,329.4,393.5,326,397.6,326z M397.6,338.4 c2.8,0,5.1-2.3,5.1-5.1s-2.3-5-5.1-5c-2.8,0-5.1,2.3-5.1,5.1S394.9,338.4,397.6,338.4z"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M582.7,332.9l48,25.1c3.2,1.7,4.5,5.7,2.8,8.9l0,0c-1.7,3.2-5.7,4.5-8.9,2.8l-48-25.1c-3.2-1.7-4.5-5.7-2.8-8.9l0,0 C575.5,332.6,579.5,331.3,582.7,332.9z"
});

var _ref84 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_14_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M635,197.1c-2.2,1.4-5,1.8-8,1.1c-0.7-0.1-1.2-0.3-1.9-0.4c-0.9-0.2-1.5-0.4-2.4-0.6c-2.8-0.4-5.5,1.2-6.4,4.1 c-0.2,0.9-0.5,1.7-0.6,2.7c-0.1,0.3-0.1,0.6-0.2,1c-0.7,3.5-2.1,6-4.5,7.5c-2.3,1.5-5.2,1.8-8.8,1c-0.4-0.1-0.8-0.2-1.1-0.3 c-0.8-0.2-1.5-0.4-2.2-0.6c-3-0.5-5.6,1.2-6.5,4.2c-0.2,0.8-0.4,1.5-0.5,2.5c-0.2,0.8-0.3,1.6-0.5,2.5c-1.3,5.3-5.8,8.2-11.2,7.3 c-1-0.2-2-0.4-2.9-0.7c-0.9-0.2-1.6-0.4-2.5-0.5c-1.9-0.3-3.2-2-3-4c0.3-2,2-3.2,4-3c1.1,0.1,2.1,0.4,3.1,0.7 c0.8,0.2,1.5,0.4,2.2,0.6c1.8,0.3,2.8-0.4,3.2-2.2c0.2-0.6,0.3-1.2,0.4-2c0.2-1,0.4-2.1,0.7-3.1c1.9-6.2,7.9-10,14.3-9.2 c1,0.2,2,0.5,3,0.6c0.3,0.1,0.8,0.2,1,0.3c1.5,0.4,2.7,0.4,3.3-0.1l0,0c0.6-0.4,1-1.4,1.3-3c0.1-0.3,0.1-0.6,0.2-0.8 c0.2-1,0.4-2.3,0.9-3.6c1.9-6.1,7.8-9.7,14.1-8.9c1.1,0.1,2.2,0.5,3.1,0.7c0.6,0.2,1.1,0.3,1.5,0.4c2.5,0.5,3.3-0.1,3.9-2.5 c0.1-0.4,0.2-1,0.3-1.3c0.3-1.3,0.5-2.9,1.2-4.5c0.9-1.7,3-2.5,4.8-1.7c1.7,0.9,2.5,3,1.7,4.8c-0.3,0.7-0.5,1.5-0.6,2.5 c-0.1,0.6-0.2,1.2-0.3,1.7C638.8,193.4,637.2,195.7,635,197.1z"
})));

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.2,50.6l-5.9-3.1c-1-0.6-2.4-0.1-2.9,1l0,0c-0.6,1-0.1,2.4,1,2.9l5.9,3.1l-3.1,5.9c-0.6,1-0.1,2.4,1,2.9l0,0 c1,0.6,2.4,0.1,2.9-1l3.1-5.9l5.9,3.1c1,0.6,2.4,0.1,2.9-1l0,0c0.6-1,0.1-2.4-1-2.9L73,52.5l3.1-5.9c0.6-1,0.1-2.4-1-2.9l0,0 c-1-0.6-2.4-0.1-2.9,1L69.2,50.6z"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M488.2,80.5c2.5,7.9-1.9,16.3-9.7,18.8c-7.9,2.5-16.3-1.9-18.8-9.7c-2.5-7.9,1.9-16.3,9.7-18.8 C477.3,68.2,485.7,72.6,488.2,80.5z M464.1,88.1c1.7,5.3,7.4,8.4,12.9,6.7c5.3-1.7,8.4-7.4,6.7-12.9c-1.7-5.3-7.4-8.4-12.9-6.7 C465.5,77,462.5,82.7,464.1,88.1z"
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  d: "M518.8,275.3l-5.9-3.1c-1-0.6-2.4-0.1-2.9,1l0,0c-0.6,1-0.1,2.4,1,2.9l5.9,3.1l-3.1,5.9c-0.6,1-0.1,2.4,1,2.9l0,0 c1,0.6,2.4,0.1,2.9-1l3.1-5.9l5.9,3.1c1,0.6,2.4,0.1,2.9-1l0,0c0.6-1,0.1-2.4-1-2.9l-5.9-3.1l3.1-5.9c0.6-1,0.1-2.4-1-2.9l0,0 c-1-0.6-2.4-0.1-2.9,1L518.8,275.3z"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M653.3,108.3c1.2,3.9-1,8-4.8,9.2c-3.9,1.2-8-1-9.2-4.8c-1.2-3.9,1-8,4.8-9.2C647.9,102.2,652.1,104.4,653.3,108.3z M641.4,112c0.9,2.7,3.6,4.1,6.3,3.2c2.7-0.9,4.1-3.6,3.2-6.3c-0.9-2.7-3.6-4.1-6.3-3.2C642.2,106.5,640.7,109.3,641.4,112z"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M527.2,364.5c1.2,3.9-1,8-4.8,9.2c-3.9,1.2-8-1-9.2-4.8c-1.2-3.9,1-8,4.8-9.2C521.9,358.4,526,360.6,527.2,364.5z M515.4,368.2c0.9,2.7,3.6,4.1,6.3,3.2c2.7-0.9,4.1-3.6,3.2-6.3c-0.9-2.7-3.6-4.1-6.3-3.2C516.1,362.7,514.6,365.6,515.4,368.2z"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M371.1,492.9c-7.6,3.1-16.4-0.6-19.5-8.3c-3.1-7.6,0.6-16.4,8.3-19.5c7.6-3.1,16.4,0.6,19.5,8.3 C382.5,480.9,378.9,489.7,371.1,492.9z M361.7,469.5c-5.2,2.1-7.7,8.1-5.6,13.3c2.1,5.2,8.1,7.7,13.3,5.6c5.2-2.1,7.7-8.1,5.6-13.3 C372.9,469.9,366.8,467.3,361.7,469.5z"
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  d: "M676.3,206.7l3.3,1.8c0.6,0.3,1.3,0.1,1.6-0.5l0,0c0.3-0.6,0.1-1.3-0.5-1.6l-3.3-1.8l1.8-3.3c0.3-0.6,0.1-1.3-0.5-1.6l0,0 c-0.6-0.3-1.3-0.1-1.6,0.5l-1.8,3.3l-3.3-1.8c-0.6-0.3-1.3-0.1-1.6,0.5l0,0c-0.3,0.6-0.1,1.3,0.5,1.6l3.3,1.8l-1.8,3.3 c-0.3,0.6-0.1,1.3,0.5,1.6l0,0c0.6,0.3,1.3,0.1,1.6-0.5L676.3,206.7z"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M700.6,338c3,3.6,2.5,9-1,12c-3.6,3-9,2.5-12-1c-3-3.6-2.5-9,1-12C692.2,333.9,697.6,334.4,700.6,338z M689.7,347.2 c2,2.5,5.7,2.8,8.2,0.8c2.5-2,2.8-5.7,0.8-8.2c-2-2.5-5.7-2.8-8.2-0.8S687.6,344.7,689.7,347.2z"
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  d: "M639,288.1l-9.5-18.9c-0.3-0.6-0.3-1.2,0.1-1.7c0.4-0.6,1-0.9,1.5-0.8l21.1,1.1c0.7,0,1.1,0.4,1.4,1 c0.3,0.6,0.3,1.2-0.1,1.7l-11.5,17.7c-0.4,0.6-1,0.9-1.5,0.8C639.8,289,639.2,288.6,639,288.1z M633.9,270.4l6.8,13.4l8.2-12.6 L633.9,270.4z"
});

var _ref94 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_11_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M568.5,438.7c-1,2.8-3.2,4.9-6.6,6.3c-0.8,0.4-1.4,0.6-2,0.9c-1,0.3-1.7,0.7-2.6,1.2c-2.9,1.4-4.1,4.9-3.1,8.1 c0.3,1,0.8,1.9,1.2,3c0.2,0.3,0.3,0.6,0.5,1c1.8,3.6,2.1,6.9,1,9.8c-1.1,3-3.6,5.1-7.4,6.9c-0.5,0.2-0.8,0.4-1.2,0.6 c-1,0.3-1.7,0.7-2.5,1c-3,1.6-4.3,5-3.2,8.2c0.3,1,0.7,1.7,1.2,2.6c0.4,0.8,1,1.6,1.2,2.6c2.3,5.8,0.4,11.4-5.2,14.4 c-1,0.6-2.1,1-3.1,1.3c-1,0.3-1.7,0.7-2.6,1.2c-1.9,1.1-4.4,0.3-5.3-1.6c-1.1-1.9-0.3-4.4,1.6-5.3c1-0.6,2.3-1,3.3-1.6 c0.8-0.4,1.7-0.7,2.5-1c1.9-1,2.3-2.3,1.5-4.1c-0.2-0.7-0.7-1.3-1-2.1c-0.5-1-1-2.1-1.5-3.5c-2.5-6.9,0.5-14.5,6.9-17.9 c1-0.6,2.1-1,3.2-1.4c0.5-0.2,0.8-0.4,1.1-0.4c1.7-0.7,2.7-1.5,3-2.4l0,0c0.3-0.9,0-1.9-0.8-3.4c-0.1-0.2-0.3-0.6-0.4-0.8 c-0.6-1-1.1-2.3-1.7-3.8c-2.3-6.8,0.6-14.2,6.9-17.5c1-0.6,2.3-1.1,3.3-1.6c0.6-0.3,1.1-0.4,1.7-0.7c2.6-1.2,3.1-2.5,2-5 c-0.2-0.5-0.5-1-0.7-1.3c-0.7-1.3-1.4-2.9-1.9-4.9c-0.5-2.2,1-4.3,3.2-4.8c2.2-0.5,4.3,1,4.8,3.2c0.2,0.9,0.7,1.7,1.1,2.7 c0.3,0.6,0.6,1,1,1.9C569.6,432.9,569.7,436,568.5,438.7z"
})));

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M527.8,193.8l-10.7-41.3c-0.7-2.8,1-5.6,3.7-6.3l0,0c2.8-0.7,5.6,1,6.3,3.7l10.7,41.3c0.7,2.8-1,5.6-3.7,6.3l0,0 C531.3,198.3,528.6,196.5,527.8,193.8z"
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M555.4,113.8l12.6-3.2c0.4-0.1,0.8,0,1,0.3c0.3,0.3,0.4,0.7,0.3,1l-3.5,12.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.4,0.1-0.8,0-1-0.3 l-9.2-9.3c-0.3-0.3-0.4-0.7-0.3-1C554.7,114.2,555,113.9,555.4,113.8z M566.7,113.1l-9,2.3l6.5,6.6L566.7,113.1z"
});

var _ref97 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_1_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M569.3,64.6c-0.5-1.7-0.2-3.6,0.9-5.6c0.2-0.4,0.5-0.9,0.8-1.1c0.3-0.6,0.6-1,0.9-1.5c0.9-1.8,0.3-4-1.4-5.1 c-0.5-0.4-1.1-0.7-1.7-1c-0.2-0.1-0.4-0.2-0.6-0.3c-2.2-1.1-3.6-2.8-4.1-4.6c-0.5-1.9-0.1-3.9,1.2-6.1c0.2-0.3,0.3-0.5,0.5-0.8 c0.3-0.5,0.6-1,0.9-1.4c1-1.9,0.3-4.1-1.4-5.2c-0.5-0.3-1-0.6-1.5-0.9c-0.6-0.3-1-0.5-1.6-0.9c-3.3-2-4.4-5.6-2.7-9.2 c0.4-0.7,0.7-1.2,1-1.8c0.3-0.6,0.6-1,0.9-1.5c0.6-1.2,2.1-1.8,3.3-1.2c1.2,0.6,1.8,2.1,1.2,3.3c-0.4,0.8-0.8,1.3-1,2 c-0.3,0.5-0.6,1-0.9,1.4c-0.6,1.1-0.4,2,0.8,2.7c0.4,0.2,0.9,0.5,1.2,0.7c0.7,0.4,1.3,0.8,2,1.1c3.8,2.6,5.1,7.4,3.1,11.6 c-0.3,0.8-0.8,1.3-1,1.9c-0.1,0.2-0.3,0.5-0.4,0.6c-0.6,1-0.9,1.7-0.7,2.2l0,0c0.2,0.5,0.7,1,1.6,1.5c0.2,0.1,0.4,0.2,0.6,0.3 c0.7,0.4,1.4,0.8,2.3,1.3c3.7,2.6,5.1,7.3,3.1,11.4c-0.4,0.8-0.8,1.3-1.1,2c-0.2,0.3-0.4,0.7-0.6,1c-0.9,1.5-0.7,2.4,0.9,3.2 c0.3,0.2,0.6,0.3,0.9,0.5c0.9,0.4,1.8,0.9,2.8,1.8s1.1,2.5,0.2,3.5c-1,1-2.5,1.1-3.5,0.2c-0.4-0.4-1-0.7-1.6-1 c-0.4-0.2-0.8-0.4-1.1-0.6C571,67.9,569.7,66.4,569.3,64.6z"
})));

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M422.4,423.1l-5.8-3.2c-1.1-0.6-2.3-0.2-2.9,0.8l0,0c-0.6,1.1-0.2,2.3,0.8,2.9l5.8,3.2l-3.2,5.8c-0.6,1.1-0.2,2.3,0.8,2.9 l0,0c1.1,0.6,2.3,0.2,2.9-0.8l3.2-5.8l5.8,3.2c1.1,0.6,2.3,0.2,2.9-0.8l0,0c0.6-1.1,0.2-2.3-0.8-2.9l-5.8-3.2l3.2-5.8 c0.6-1.1,0.2-2.3-0.8-2.9l0,0c-1.1-0.6-2.3-0.2-2.9,0.8L422.4,423.1z"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  d: "M194.9,91.2c-16.4,0-29.7-13.3-29.7-29.7s13.3-29.7,29.7-29.7s29.7,13.3,29.7,29.7S211.3,91.2,194.9,91.2z M194.9,41.3 c-11.2,0-20.3,9.1-20.3,20.3c0,11.2,9.1,20.3,20.3,20.3c11.2,0,20.3-9.1,20.3-20.3S206,41.3,194.9,41.3z"
});

var _ref100 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_16_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M135.9,329.8c-2.4-0.9-4.4-2.8-5.8-5.6c-0.3-0.6-0.6-1.2-0.8-1.8c-0.4-0.8-0.7-1.5-1-2.2c-1.4-2.5-4.4-3.5-7.1-2.6 c-0.9,0.3-1.6,0.8-2.5,1.1c-0.3,0.1-0.6,0.3-0.8,0.4c-3.1,1.6-6.1,1.9-8.6,1c-2.6-1-4.7-3.1-6.1-6.4c-0.2-0.4-0.3-0.8-0.5-1.1 c-0.3-0.8-0.7-1.4-1-2.1c-1.4-2.7-4.5-3.7-7.2-2.7c-0.8,0.3-1.4,0.7-2.2,1c-0.8,0.4-1.4,0.8-2.3,1.1c-5.1,2.2-10,0.5-12.7-4.4 c-0.5-1-0.9-1.8-1.2-2.7c-0.4-0.8-0.7-1.5-1-2.2c-1-1.7-0.4-3.8,1.3-4.9c1.7-1,3.8-0.4,4.9,1.3c0.6,1,1,2,1.4,2.9 c0.3,0.8,0.7,1.4,1,2.1c0.9,1.6,2,2,3.7,1.2c0.6-0.3,1.2-0.6,1.8-0.9c1-0.5,1.9-1,3-1.4c6.1-2.3,12.8,0.1,15.9,5.8 c0.6,1,1,1.9,1.3,2.8c0.1,0.3,0.3,0.7,0.4,1c0.7,1.4,1.3,2.4,2,2.6l0,0c0.7,0.2,1.7,0,3.1-0.7c0.3-0.1,0.5-0.3,0.8-0.4 c1-0.5,2.1-1,3.3-1.5c6-2.2,12.6,0.2,15.6,5.7c0.6,1,1,2,1.4,3c0.2,0.5,0.5,1,0.7,1.5c1,2.2,2.2,2.7,4.4,1.6 c0.4-0.2,0.8-0.4,1.2-0.7c1.1-0.7,2.5-1.3,4.3-1.7c1.9-0.4,3.8,0.8,4.2,2.7s-0.8,3.8-2.7,4.2c-0.8,0.2-1.5,0.6-2.4,1 c-0.5,0.3-1,0.6-1.6,0.9C141.1,330.5,138.3,330.7,135.9,329.8z"
})));

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.9,212.5l-9.4-35.7c-0.3-1,0-2.2,0.8-3c0.8-0.8,1.9-1,3-0.8l35.7,9.6c1,0.3,1.9,1.1,2.2,2.2s0,2.2-0.8,3l-26.2,26 c-0.8,0.8-1.9,1-3,0.8C112.9,214.4,112.2,213.5,111.9,212.5z M109.7,180.3l6.8,25.5l18.7-18.5L109.7,180.3z"
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M317.1,313.3l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7c-0.9-0.9-2.2-0.9-3.1,0l0,0 c-0.9,0.9-0.9,2.2,0,3.1l4.7,4.7l-4.7,4.7c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0l4.7-4.7l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0 l0,0c0.9-0.9,0.9-2.2,0-3.1L317.1,313.3z"
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M117.2,125.8L64.1,115c-3.5-0.8-5.9-4.2-5.1-7.8l0,0c0.8-3.5,4.2-5.9,7.8-5.1l53.1,10.8c3.5,0.8,5.9,4.2,5.1,7.8l0,0 C124.3,124.2,120.8,126.5,117.2,125.8z"
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.5,218.1l4.7-4.7c0.9-0.9,0.9-2.2,0-3.1l0,0c-0.9-0.9-2.2-0.9-3.1,0l-4.7,4.7l-4.7-4.7c-0.9-0.9-2.2-0.9-3.1,0l0,0 c-0.9,0.9-0.9,2.2,0,3.1l4.7,4.7l-4.7,4.7c-0.9,0.9-0.9,2.2,0,3.1l0,0c0.9,0.9,2.2,0.9,3.1,0l4.7-4.7l4.7,4.7c0.9,0.9,2.2,0.9,3.1,0 l0,0c0.9-0.9,0.9-2.2,0-3.1L45.5,218.1z"
});

var _ref105 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.3,421.1c-4.1,0-7.3-3.3-7.3-7.3c0-4.1,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3C158.6,417.8,155.3,421.1,151.3,421.1z M151.3,408.7c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1S154,408.7,151.3,408.7z"
});

var _ref106 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.5,424.1l-30.6-44.7c-2.1-3-1.2-7.1,1.7-9.2l0,0c3-2.1,7.1-1.2,9.2,1.7l30.6,44.7c2.1,3,1.2,7.1-1.7,9.2l0,0 C74.6,427.9,70.5,427.2,68.5,424.1z"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  d: "M210.3,191.2l-3.1,5.9c-0.6,1-0.1,2.4,1,2.9l0,0c1,0.6,2.4,0.1,2.9-1l3.1-5.9l5.9,3.1c1,0.6,2.4,0.1,2.9-1l0,0 c0.6-1,0.1-2.4-1-2.9l-5.9-3.1l3.1-5.9c0.6-1,0.1-2.4-1-2.9l0,0c-1-0.6-2.4-0.1-2.9,1l-3.1,5.9l-5.9-3.1c-1-0.6-2.4-0.1-2.9,1l0,0 c-0.6,1-0.1,2.4,1,2.9L210.3,191.2z"
});

var _ref108 =
/*#__PURE__*/
React.createElement("path", {
  d: "M303.2,212.2c7.9-2.5,16.3,1.9,18.8,9.7c2.5,7.9-1.9,16.3-9.7,18.8c-7.9,2.5-16.3-1.9-18.8-9.7 C290.9,223.1,295.3,214.8,303.2,212.2z M310.8,236.3c5.3-1.7,8.4-7.4,6.7-12.9c-1.7-5.3-7.4-8.4-12.9-6.7c-5.3,1.7-8.4,7.4-6.7,12.9 C299.7,235,305.4,237.9,310.8,236.3z"
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  d: "M393.6,242.5l18.3-13.5c0.6-0.4,1.2-0.5,1.9-0.2c0.7,0.3,1,0.9,1.1,1.5l2.6,22.6c0.1,0.7-0.2,1.3-0.8,1.7s-1.2,0.5-1.9,0.2 l-20.9-9.1c-0.7-0.3-1-0.9-1.1-1.5C392.7,243.6,393,242.9,393.6,242.5z M411.4,234l-13.1,9.6l14.9,6.5L411.4,234z"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.5,265.6l8-27.9c0.6-1.9,2.5-3,4.4-2.4l0,0c1.9,0.6,3,2.5,2.4,4.4l-8,27.9c-0.6,1.9-2.5,3-4.4,2.4l0,0 C162,269.4,160.9,267.5,161.5,265.6z"
});

var _ref111 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_15_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M287.3,131.2c-1.7,0.5-3.6,0.2-5.6-0.9c-0.4-0.2-0.9-0.5-1.1-0.8c-0.6-0.3-1-0.6-1.5-0.9c-1.8-0.9-4-0.3-5.1,1.4 c-0.4,0.5-0.7,1.1-1,1.7c-0.1,0.2-0.2,0.4-0.3,0.6c-1.1,2.2-2.8,3.6-4.6,4.1c-1.9,0.5-3.9,0.1-6.1-1.2c-0.3-0.2-0.5-0.3-0.8-0.5 c-0.5-0.3-1-0.6-1.4-0.9c-1.9-1-4.1-0.3-5.2,1.4c-0.3,0.5-0.6,1-0.9,1.5c-0.3,0.6-0.5,1-0.9,1.6c-2,3.3-5.6,4.4-9.2,2.7 c-0.7-0.4-1.2-0.7-1.8-1c-0.6-0.3-1-0.6-1.5-0.9c-1.2-0.6-1.8-2.1-1.2-3.3c0.6-1.2,2.1-1.8,3.3-1.2c0.8,0.4,1.3,0.8,2,1 c0.5,0.3,1,0.6,1.4,0.9c1.1,0.6,2,0.4,2.7-0.8c0.2-0.4,0.5-0.9,0.7-1.2c0.4-0.7,0.8-1.3,1.1-2c2.6-3.8,7.4-5.1,11.6-3.1 c0.8,0.3,1.3,0.8,1.9,1c0.2,0.1,0.5,0.3,0.6,0.4c1,0.6,1.7,0.9,2.2,0.7l0,0c0.5-0.2,1-0.7,1.5-1.6c0.1-0.2,0.2-0.4,0.3-0.6 c0.4-0.7,0.8-1.4,1.3-2.3c2.6-3.7,7.3-5.1,11.4-3.1c0.8,0.4,1.3,0.8,2,1.1c0.3,0.2,0.7,0.4,1,0.6c1.5,0.9,2.4,0.7,3.2-0.9 c0.2-0.3,0.3-0.6,0.5-0.9c0.4-0.9,0.9-1.8,1.8-2.8c1-1,2.5-1.1,3.5-0.2c1,1,1.1,2.5,0.2,3.5c-0.4,0.4-0.7,1-1,1.6 c-0.2,0.4-0.4,0.8-0.6,1.1C290.6,129.4,289.1,130.7,287.3,131.2z"
})));

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M328.1,23l36,8.4c1.1,0.2,1.9,1,2.3,2.1c0.3,1,0,2.2-0.7,3l-25.2,27c-0.7,0.8-1.9,1.1-3,0.9c-1.1-0.2-1.9-1-2.3-2.1 l-10.7-35.4c-0.3-1,0-2.2,0.7-3C325.9,23,327,22.8,328.1,23z M357.5,36.1l-25.7-6l7.6,25.2L357.5,36.1z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 1334",
    style: {
      "enableBackground": "new 0 0 750 1334"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112);
};

export default __webpack_public_path__ + "static/media/patterns_mobile.6c8df42e.svg";
export { SvgComponent as ReactComponent };